import React from 'react';
import styled from 'styled-components';
import cookie from 'react-cookies';
import { LoadingOutlined } from '@ant-design/icons';
import bg from '../../../imges/securityStaff/bg.jpg';
import search from '../../../imges/securityStaff/search.png';
import shapex from '../../../imges/securityStaff/shapex.png';
import portrait from '../../../imges/securityStaff/portrait.png';
import renzheng from '../../../imges/securityStaff/renzheng.png';
import lizhi from '../../../imges/securityStaff/lizhi.png';
import Modal from './Modal';
import ImgModal from './ImgModal';
import Toast from '../../../component/toast';
import API from '../../../server/index';
// import { Provider } from 'mobx-react';

export default function () {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [inputVal, setInputVal] = React.useState<string>('');
  const [showModal, setShowModal] = React.useState<boolean>(false);
  const [showResult, setShowResult] = React.useState<boolean>(false);
  const [defaultMsg, setDefaultMsg] = React.useState<string>('');
  const [resultList, setResultList] = React.useState<any[]>([]);
  const [imgShow, setImageShow] = React.useState({ visible: false, src: '' });

  // 搜索员工
  const searchEmployees = async () => {
    setShowResult(false);
    if (!inputVal.trim().length) {
      Toast('请输入遥望员工花名/真实姓名/手机号');
      return
    }
    const tmpToken = sessionStorage.getItem('tmpToken');
    if (!tmpToken) {
      setShowModal(true);
    } else {
      if (loading) return;
      setLoading(true);
      try {
        const res = await API.ApiEmployeeQuery28875({
          key: inputVal.trim(),
          tmpToken
        })
        setLoading(false);
        setShowResult(true);
        setDefaultMsg(res?.data?.defaultMsg || '');
        setResultList(res?.data?.employeeInfoList || []);
      } catch (error) {
        setLoading(false);
        if (error?.code === '20133') { // token
          setShowModal(true);
          sessionStorage.remove('tmpToken');
        }
      }
    }
  }
  
  return (
    <Container>
      <div className="center-wrap">
        <h1>遥望员工防伪查询</h1>
        {/* 输入框 */}
        <div className="input-wrap">
          <i />
          <input
            type='text'
            value={inputVal}
            id="securityStaffInput"
            autoComplete='off'
            placeholder="请输入遥望员工花名/真实姓名/手机号"
            onChange={(e)=> setInputVal(e.target.value)}
            maxLength={11}
            onKeyUp={(e) => {
              if(e.keyCode === 13) {
                searchEmployees()
              }
            }}
          />
          <div className={['button', loading ? 'loading' : ''].join(' ')} onClick={searchEmployees}>
            {loading && <LoadingOutlined />}
            搜 索
          </div>
        </div>
        {/* 结果展示 */}
        {showResult && (
          <div className="result-wrap">
            <p>查询结果：</p>
            {resultList.length ? (
              <div className="result-list">
                {resultList.map((item, index) => (
                  <div key={index} className={['result-item', !item.isLeave ? 'employees' : 'departure'].join(' ')}>
                    <img
                      className={item.iconUrl ? 'click' : ''}
                      src={item.iconUrl || portrait}
                      alt="employees_img"
                      onClick={() => {
                        if (item.iconUrl) {
                          setImageShow({ visible: true, src: item.iconUrl })
                        }
                      }}
                    />
                    <div className="middle-area">
                      <h3>{`${item.nickName}(${item.realName})`}</h3>
                      <p>
                        {item.position && <span className="gray">{item.position}</span>}
                        <span>{item.mobile}</span>
                      </p>
                    </div>
                    <div className="right-area">
                      <i />
                      {!item.isLeave ? '认证员工' : '已离职'}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div
                className="empty-wrap"
                dangerouslySetInnerHTML={{
                  __html: defaultMsg,
                }}
              />
            )}
          </div>
        )}
      </div>
      <Modal
        visible={showModal}
        close={(isLogin) => {
          setShowModal(false);
          if (isLogin) {
            searchEmployees();
          }
        }}
      />
      <ImgModal {...imgShow} close={() => setImageShow({ visible: false, src: '' })} />
    </Container>
  )
}

const Container = styled.div`
  background: #333 url(${bg}) no-repeat center 0;
  background-size:  cover;
  height: 768px;
  display: flex;
  justify-content: center;
  .center-wrap {
    padding-top: 148px;
    h1 {
      text-align: center;
      font-size: 40px;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 52px;
      padding-bottom: 51px;
      margin: 0;
    }

    .input-wrap {
      width: 800px;
      height: 60px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;

      i {
        width: 24px;
        height: 24px;
        background: url(${search}) no-repeat center center;
        background-size: 100% 100%;
        display: block;
        margin: 0 18px;
        flex-grow: 0;
        flex-shrink: 0;
      }

      input {
        font-size: 20px;
        font-weight: 400;
        color: #FFFFFF;
        flex-grow: 1;
        height: 60px;
        line-height: 60px;
        background: transparent;
        border: none;
        outline: none;
      }
      input::-webkit-input-placeholder{
        color: #FFFFFF;
        opacity: 0.6;
      }
      input::-ms-input-placeholder {
        color: #FFFFFF;
        opacity: 0.6;
      }

      .button {
        width: 90px;
        height: 48px;
        text-align: center;
        background: #1968FC;
        border-radius: 4px;
        font-size: 20px;
        font-weight: 300;
        color: #FFFFFF;
        line-height: 48px;
        margin: 0 6px;
        flex-grow: 0;
        flex-shrink: 0;
        cursor: pointer;
        user-select: none;
        transition: all 0.1s;
        &.loading {
          width: 125px;
        }
        .anticon-loading {
          margin: 0 10px 0 5px;
        }
      }
    }

    .result-wrap {
      padding-top: 30px;

      & > p {
        font-size: 20px;
        color: #FFFFFF;
        line-height: 26px;
        padding-bottom: 22px;
        margin: 0;
      }

      .empty-wrap {
        width: 800px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 20px;
        opacity: 0.9;
        padding: 25px;

        h3 {
          font-size: 20px;
          font-weight: bold;
          color: #2C2543;
          line-height: 26px;
          padding-bottom: 13px;
          display: flex;
          align-items: center;
          margin: 0;
          i {
            width: 20px;
            height: 21px;
            background: url(${shapex}) no-repeat center center;
            background-size: 100% 100%;
            display: block;
            margin-right: 10px;
          }
        }

        p {
          font-size: 18px;
          margin: 0;
          color: #2C2543;
          line-height: 32px;
        }
      }

      .result-list {
        width: 800px;
        .result-item {
          width: 390px;
          height: 105px;
          background: rgba(255, 255, 255, 0.9);
          border-radius: 20px;
          opacity: 0.9;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 25px;
          float: left;
          margin-bottom: 20px;

          img {
            width: 55px;
            height: 55px;
            border-radius: 12px;
            flex-grow: 0;
            flex-shrink: 0;

            &.click {
              cursor: pointer;
            }
          }

          .middle-area {
            padding: 0 15px;
            flex-grow: 1;
            h3 {
              font-size: 18px;
              line-height: 18px;
              margin: 0;
              padding-bottom: 10px;
            }

            p {
              margin: 0;
              span {
                font-size: 14px;
                color: #2C2543;
                line-height: 14px;

                &.gray {
                  color: #75839B;
                  padding-right: 15px;
                }
              }
            }
          }

          .right-area {
            flex-grow: 0;
            flex-shrink: 0;
            font-size: 12px;
            font-weight: 400;
            line-height: 18px;

            i {
              display: block;
            }
          }

          &:nth-child(2n + 1) {
            margin-right: 20px;
          }

          &.employees {
            .middle-area h3, .right-area {
              color: #00B630;
            }

            .right-area i {
              width: 25px;
              height: 30px;
              background: url(${renzheng}) no-repeat center center;
              background-size: 100% 100%;
              margin: 0 auto 4px;
            }
          }

          &.departure {
            .middle-area h3, .right-area {
              color: #F76C2D;
            }

            .middle-area span {
              text-decoration: line-through;
            }

            .right-area i {
              width: 32px;
              height: 27px;
              background: url(${lizhi}) no-repeat center center;
              background-size: 100% 100%;
              margin: 0 auto 5px;
            }
          }
        }
      }
    }
  }
`